import {Link} from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Sidebar from './sidebar';
import { ArrowLeft, } from 'react-feather';
import React,{ useState } from 'react';
import { FaFacebook, FaTwitter, FaWhatsapp, FaCopy } from "react-icons/fa";
import { QRCodeCanvas } from "qrcode.react";
import useStoreSetupCheck from './useStoreSetupCheck';

function SellerShare(){
    const setupStatus = useStoreSetupCheck();
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const token = localStorage.getItem("access_token");
    const [copied, setCopied] = useState(false);
    const vendor_username = localStorage.getItem('vendor_username');
    const vendor_shopname = localStorage.getItem('vendor_shopname');
    
    var shopName  = vendor_shopname;
    var shopLink  = 'https://kadhr.com/'+vendor_username;

    const shareText = `Wassgud, ${shopName} here, we got some cool merchandise in our store, Check us out on ${shopLink}`;
    const socialLinks = {
        whatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent(shareText)}`,
        twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shopLink)}`,
        instagram: "https://www.instagram.com/", // Instagram doesn't allow direct URL sharing
    };

    const copyToClipboard = () => {
        navigator.clipboard.writeText(shopLink);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset message after 2 seconds
    };
    return (
        <>                                                 
            <Helmet>
                <title>Share</title>
                <meta name="description" content={`Share`} />
            </Helmet>
            <section className="container mtopcon dashb">         
                <div className="row">
                    
                        <div className="col-12 col-lg-2 dash-min mb-3">
                            <div className="nav-left-sidebar sidebar-dark pc">
                                <div className="slimScrollDiv" ><div className="menu-list" >
                                    <nav className="navbar navbar-expand-lg navbar-light nav-l-con">
                                        <a className="d-xl-none d-lg-none" href="#"></a>
                                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                            <span className="navbar-toggler-icon"></span>
                                        </button>
                                        <div className="collapse navbar-collapse" id="navbarNav">
                                            <Sidebar/>
                                        </div>
                                    </nav>
                                </div><div className="slimScrollBar"></div><div className="slimScrollRail"></div></div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-10 dash-max">
                            <div className="row ph-header-con">
                                <div className="col-7 pt-2"><h6 className="pageheader-title">Share Shop</h6></div>
                                <div className="col-5"><Link to="/seller/dashboard"><button className="btn btn-primary f85 float-right"><ArrowLeft/></button></Link></div>
                            </div>
                            
                            <div className="row mb-3">
                                <div className="container d-flex justify-content-center mt-5">
                                    <div className="card text-center shadow-xs p-4 rounded" style={{ maxWidth: "400px", width: "100%" }}>
                                        {/* Shop Name */}
                                        <h3 className="fw-bold mb-3">{shopName}</h3>

                                        {/* QR Code */}
                                        <div className="my-3">
                                        <QRCodeCanvas value={shopLink} size={200} />
                                        </div>

                                        {/* Copy Link */}
                                        <div className="mt-2 mb-3">
                                            <div className="mt-4 text-center mb-4"><button className="main-btn-mini btn-outline text-dark bgdefault-a border-dark border-5 font-bold"  onClick={copyToClipboard}><FaCopy /> {copied ? "Copied!" : "Copy Link"}</button></div>   
                                        </div>
                                        <hr/>
                                        <h6 className="text-center mt-3 font-bold">Share On</h6>
                                        {/* Share Buttons */}
                                        <div className="d-flex justify-content-around mt-4 mb-3 font9 pb-2">
                                            <a href={socialLinks.whatsapp} target="_blank" rel="noopener noreferrer" className="btn btn-success br10 pt-2 pb-2 ms-2">
                                                <FaWhatsapp size={24} />
                                            </a>
                                            <a href={socialLinks.twitter} target="_blank" rel="noopener noreferrer" className="btn btn-info br10 pt-2 pb-2 text-white ms-2">
                                                <FaTwitter size={24} />
                                            </a>
                                            <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer" className="btn btn-primary br10 pt-2 pb-2 ms-2">
                                                <FaFacebook size={24} />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>                       


                    </div>
                </div>


            </section>
        </>
    )
}

export default SellerShare;